module.exports = __webpack_public_path__ + "img/watchon_logo.2c2bb909.png";